<div
  *ngIf="type !== TOP_LOCATIONS"
  id="vxapp_map"
  [attr.data-avuxi-key]="LSE_TYPES[type]"
  [attr.data-location]="position"
  data-page-style="map-with-scores-2"
  data-force-metric="true">
</div>

<div
  *ngIf="type === TOP_LOCATIONS"
  id="vxapp_location"
  data-force-metric="true"
  [attr.data-avuxi-key]="LSE_TYPES[type]"
  [attr.data-location]="position">
</div>
